module.exports = __webpack_public_path__ + "media/navi/populife_open-5a75e817.png";